import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { styled, TableCell, tablePaginationClasses } from '@mui/material';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';
import { theme } from 'v3/styles/global-styles';

export const TableCellStyled = styled(TableCell)(() => ({
  color: 'white',
  maxWidth: '40%',
  background: theme.palette.primary.dark,
  borderBottomColor: 'transparent',
}));

export const TableCellGroup = styled(TableCellStyled)(() => ({
  background: 'transparent',
  lineHeight: '1rem',
}));

export const TableCellGroupSmall = styled(TableCellStyled)(() => ({
  background: 'transparent',
  lineHeight: '1rem',
  width: '15rem',
}));

export const IconAlignmentAndSwitchCommon = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  gap: '2rem',
}));

export const EditOutlinedIconStyle = styled(EditOutlinedIcon)(() => ({
  cursor: 'pointer',
}));

export const TablePaginationStyles = {
  color: theme.palette.common.white,
  borderTop: `1px solid ${theme.palette.common.white}`,

  [`& .${tablePaginationClasses.select}:focus`]: {
    backgroundColor: 'transparent',
  },

  [`& .${tablePaginationClasses.selectIcon}`]: {
    color: theme.palette.common.white,
  },
};

export const InlineContainer = styled('div')(() => ({
  display: 'flex',
  whiteSpace: 'pre-wrap',
}));

export const CustomSubtitleMedium = styled(SubtitleMedium)(() => ({
  maxWidth: '19rem',
}));

export const PixKeySubtitle = styled(SubtitleMedium)(() => ({
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));
